import React from 'react'
import { MainView } from '../Workspace/WorkspaceStyles'
import ProjectLoader from './index'
import styled from '../../theme/styled'
import { Blinds, LoadingWrapper } from '../Shared/LoadIndicators'

const Overlay = require('./loading-overlay.svg')
const LoadingBlock = require('../Shared/Images/load-icon.svg')
const ErrorBlock = require('../Shared/Images/error-icon.svg')

const CenteredView = styled(MainView)`
  background-image: url(${Overlay});
  background-size: 100% 100%;
  align-items: center;
  justify-content: center;
`

const FullSize = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
`

/* A convenience wrapper that takes care of errors from ProjectLoader. It's okay
   to use ProjectLoader without this. */
export function withLoadedProject(Component: React.ComponentType) {
  return (
    <ProjectLoader
      render={(loading, error) => {
        if (loading) {
          return (
            <FullSize>
              <CenteredView>
                <LoadingWrapper>
                  <img src={LoadingBlock} alt="" />
                  Loading...
                </LoadingWrapper>
              </CenteredView>
            </FullSize>
          )
        }

        if (error) {
          return (
            <FullSize>
              <CenteredView>
                <Blinds>
                  <LoadingWrapper style={{ color: 'white' }}>
                    <img src={ErrorBlock} alt="" />
                    Error: {error}
                  </LoadingWrapper>
                </Blinds>
              </CenteredView>
            </FullSize>
          )
        }
        return <Component />
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/Components/ProjectLoader/projectLoadWrapper.tsx